import { request as sonataRequest } from 'sonata-react-components';

import type { MultiFlightEntityType } from 'sonata-static-storage/lib/common/common.types';

const QUICK_REPORT_ENTITY_PATH: Record<MultiFlightEntityType, string> = {
  campaignPlan: 'campaignPlan',
  insertionOrder: 'insertionOrder',
  lineItem: 'lineItems'
};

// signal lets react-query abort the request when the quick report closes
export function getQuickReport<T>(
  entityType: MultiFlightEntityType,
  userId: string,
  entityId: string,
  metrics: string[],
  signal?: AbortSignal
): Promise<T> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/${QUICK_REPORT_ENTITY_PATH[entityType]}/${userId}/${entityId}/quickReport`,
    {
      method: 'GET',
      params: { metrics },
      signal
    }
  );
}
